import React, { useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Tooltip from "@mui/material/Tooltip";
import styled from "styled-components";

import {
  UpfrontPaymentFieldRowTitle,
  UpfrontPaymentTooltipContent,
  UpfrontPaymentTooltipPopper,
} from "./UpfrontPayment.styles";

const Trigger = styled.button<{ $compact: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  width: ${({ $compact }) => ($compact ? 24 : 44)}px;
  height: ${({ $compact }) => ($compact ? 24 : 44)}px;
  flex: 0 0 ${({ $compact }) => ($compact ? 24 : 44)}px;
  padding: 0;
  border: 0;
  /* Keep the 44px tap target within the layout of a 24px title row. */
  margin: ${({ $compact }) => ($compact ? "0" : "-10px 0")};
  color: inherit;
  background: transparent;
  cursor: pointer;

  svg {
    margin: 0;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.greenDark};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const BillingInfoTitle = styled(UpfrontPaymentFieldRowTitle)`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  overflow: visible;
  white-space: nowrap;

  .billing-info-title-label {
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const BillingInfoTooltip: React.FC<{
  label: string;
  content: React.ReactNode;
  icon: React.ReactNode;
  placement?: "top" | "top-start";
  compact?: boolean;
}> = ({ label, content, icon, placement = "top", compact = false }) => {
  const [open, setOpen] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <span
        style={{
          display: "inline-flex",
          flex: compact ? "0 0 24px" : "0 0 44px",
          verticalAlign: "middle",
        }}
      >
        <Tooltip
          arrow
          describeChild
          open={open}
          onClose={() => setOpen(false)}
          title={
            <UpfrontPaymentTooltipContent>
              {content}
            </UpfrontPaymentTooltipContent>
          }
          placement={placement}
          PopperComponent={UpfrontPaymentTooltipPopper}
          PopperProps={{
            modifiers: [
              { name: "preventOverflow", options: { padding: 16 } },
              { name: "offset", options: { offset: [0, compact ? 0 : -16] } },
            ],
          }}
          disableFocusListener
          disableHoverListener
          disableTouchListener
        >
          <Trigger
            $compact={compact}
            type="button"
            aria-label={label}
            aria-expanded={open}
            onClick={() => setOpen((current) => !current)}
            onKeyDown={(event) => {
              if (event.key === "Escape") setOpen(false);
            }}
          >
            {icon}
          </Trigger>
        </Tooltip>
      </span>
    </ClickAwayListener>
  );
};
